import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import OrderListTitle from './Title';
import OrderListItem from './Item';

const { node, string } = PropTypes;

/**
 * OrderList
 *
 * This component is in charge of displaying
 * an order list
 *
 * @param {string} children // Anything that can be rendered: numbers, strings, elements or an array (or fragment).
 * @param {string} className // className needed by styled components.
 *
 * @return {jsx}
 */

class OrderList extends PureComponent {
  static Title = OrderListTitle;
  static Item = OrderListItem;

  /**
   * PropTypes validation
   */
  static propTypes = {
    className: string,
    children: node,
  };

  /**
   * Default propTypes
   */
  static defaultProps = {
    className: '',
    children: null,
  };

  /**
   * Render function
   */
  render() {
    const { className, children } = this.props;

    return <ul className={className}>{children}</ul>;
  }
}

export default styled(OrderList)`
  list-style-type: none;

  margin-bottom: 3rem;
`;



// WEBPACK FOOTER //
// ./src/components/OrderList/index.js